import { render, staticRenderFns } from "./CoursesListComponent.vue?vue&type=template&id=322e6142&"
import script from "./CoursesListComponent.vue?vue&type=script&lang=js&"
export * from "./CoursesListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports